import { getPrimus } from '../../../utils/primus';
import { CLIENT_ORIGIN_WS_EVENTS } from '~/constants';

export const updateChatbotSettings = ({ userID, chatbot_settings }) => {
  const primus = getPrimus();

  return primus.emit(
    CLIENT_ORIGIN_WS_EVENTS.COLLECTION,
    { cid: 'users' },
    {
      _id: userID,
      config: {
        chatbot_settings,
      },
    }
  );
};
